import type { ERPConnectionInfo } from '@calculom/report-designer';

export const MOCK_CONNECTIONS: ERPConnectionInfo[] = [
  { id: 'conn-1', name: 'Odoo Production', erpType: 'odoo' },
  { id: 'conn-2', name: 'Acumatica Cloud', erpType: 'acumatica' },
  { id: 'conn-3', name: 'QuickBooks Online', erpType: 'quickbooks' },
];
